import {
	Message
} from 'element-ui'
import store from '../store/store.js'
import util from './util.js'
import router from '../router/index.js'
import config from './electronConfig.js'
import Vue from 'vue'

let userAgent = navigator.userAgent.toLowerCase()
let ipc = null
try {
	if (userAgent.indexOf('electron/') !== -1 && typeof window !== 'undefined' && window.require) {
		ipc = window.require('electron').ipcRenderer
	}
} catch (e) {
	ipc = null
}

let websock = null
let messageCallback = null
let errorCallback = null
// let netState = true; //网络状态
// 同事帮聊+访客开口推送12
// 自己说话 通过推送99  上传文件



//服务器端给客户端推送的消息类型
let WSConnectSuccess = '1' //客服端与服务端WS建立连接成功
let ConnectWithToken = '2' //客服ws携带token登录
let WSServerBack = '99' //服务器给出的消息回应
let WSClientBrowsering = '10' //客户进站---浏览中
let WSClientTalking = '11' //客户开始会话通知---会话中
let WSInChat = '12' //聊天消息（双向）
let WSWorkInChat = '9' //同事聊天消息（双向）
let onlineCustomerAdd = '210' //在线访客会话加入
let onlineCustomerLeave = '220' //在线访客会话加入
let WSClientLeave = '13' //客户离开站点通知 ----离开
let WSCustomLeave = '14' //客服主动结束（客户）会话
let WSChatEnd = '16' //会话结束通知
let WSLeaveToChat = '19' //客户再次发起会话，从已离开中移到会话中
let WSHeartBeat = '20' //心跳
let onlineCusromerAdd = '210' //添加在线访客
let onlineCusromerLeave = '220'
let resetWorkList = '30'
let msgSendError = "32"	//消息发送失败

let WSMsgRev = "999"	//消息回执

const trusteeshipStatus = "33" // 托管状态
const readedMsg = "34" // 消息已读
let connectCount = 12 //ping和重连次数上限

//服务器端给客户端回应的业务消息码
let WSLoginSuccess = 200 //用户登录ws成功

var unReadTotal = 0



// var reconnectionCount = 0

var StateMachine = require('javascript-state-machine');


export var codeAndTips = {
	offlineCode: 0,
	offlineTips: '网络已断开，正在尝试重连中...', //断线code及提示
	conningCode: 1,
	conningTips: '网络已连接，正在重连中...', //正在重连code及提示
	connectFailedCode: 2,
	connectFailedTips: '网络重连失败，请确认网络状态后重新登录', //连接失败code及提示
	connectedCode: 3,
	connectedTips: '网络已重连成功', //连接成功code及提示

}



// var sendFixHeartTimer = null


// var connection = navigator.connection
// var type = connection.effectiveType


// function updateConnectionStatus() {

//   type = connection.effectiveType;
//   console.log("connection.rtt",connection.rtt,'connection.downlink',connection.downlink)
//   console.log("网络状况从 " + type + " 切换至" + connection.effectiveType);
// }


// connection.addEventListener('change', updateConnectionStatus);

if (document.addEventListener) {
	document.addEventListener('webkitvisibilitychange', function () {
		unReadTotal = 0
	})
}


// window.addEventListener('online', function() {
// 	netState = true;
// 	console.error("=>ws.来网了1", new Date())
// 	//util.setWsState("1")
// });
// window.addEventListener('offline', function() {
// 	netState = false;
// 	console.error("=>ws.断网了2", new Date())
// });




export var wsState = new StateMachine({
	init: 'sm_init',
	transitions: [{
		name: 'initToConing',
		from: 'sm_init',
		to: 'sm_coning'
	},
	{
		name: 'coningToLoging',
		from: 'sm_coning',
		to: 'sm_loging'
	},
	{
		name: 'logingToLogined',
		from: 'sm_loging',
		to: 'sm_logined'
	},
	{
		name: 'loginedToPing',
		from: 'sm_logined',
		to: 'sm_ping'
	},
	{
		name: 'loginedAndFailedToLogout',
		from: ['sm_logined', 'sm_con_failed'],
		to: 'sm_logout'
	},
	{
		name: 'pingToConFailed',
		from: 'sm_ping',
		to: 'sm_con_failed'
	},
	{
		name: 'pingToNnRecon',
		from: 'sm_ping',
		to: 'sm_nn_recon'
	},

	{
		name: 'logoutToInit',
		from: 'sm_logout',
		to: 'sm_init'
	},
	{
		name: 'nnReconToConing',
		from: 'sm_nn_recon',
		to: 'sm_coning'
	},
	{
		name: 'nnReconToFailed',
		from: 'sm_nn_recon',
		to: 'sm_con_failed'
	},
	{
		name: 'coningToLogout',
		from: 'sm_coning',
		to: 'sm_logout'
	},
	{
		name: 'loginedToLogout',
		from: 'sm_logined',
		to: 'sm_logout'
	},

	],
	methods: {
		onInitToConing: function () {
			console.log('I onInitToConing', wsState.state)
			onInitToConingFun()
		},
		onConingToLoging: function () {
			console.log('I onConingToLoging', wsState.state)
			onConingToLogingFun()
		},

		onLogingToLogined: function () {
			console.log('I onLogingToLogined', wsState.state)
			onLogingToLoginedFun()
		},
		onLoginedToPing: function () {
			console.log('I onLoginedToPing', wsState.state)
			onLoginedToPingFun()
		},
		onLoginedAndFailedToLogout: function () {
			console.log('I onLoginedAndFailedToLogout', wsState.state)
			onLoginedAndFailedToLogoutFun()
		},
		onPingToConFailed: function () {
			console.log('I onPingToConFailed', wsState.state)
			onPingToConFailedFun()
		},
		onPingToNnRecon: function () {
			console.log('I onPingToNnRecon', wsState.state)
			onPingToNnReconFun()
		},
		onLogoutToInit: function () {
			console.log('I onLogoutToInit', wsState.state)
			onLogoutToInitFun()
		},
		onNnReconToConing: function () {
			console.log('I onNnReconToConing', wsState.state)
			onNnReconToConingFun()
		},
		onNnReconToFailed: function () {
			console.log('I nnReconToFailed', wsState.state)
			onNnReconToFailedFun()
		},
		onConingToLogout: function () {
			console.log('I onConingToLogout', wsState.state)
			onConingToLogoutFun()
		},
		onLoginedToLogout: function () {
			console.log('I onLoginedToLogout', wsState.state)
			onLoginedToLogoutFun()
		},
	}
})


// http登录成功，获取token和连接地址，进行ws连接
function onInitToConingFun() {
	console.log("onInitToConingFun", wsState.state)
	initWebSocket()
}

function onConingToLogingFun() {
	websock.connected = true;
	console.log("onConingToLogingFun", wsState.state)
	const token = util.getLocalToken()
	const msgObj = {
		"type": ConnectWithToken,
		"token": token,
	}
	websocketSend(msgObj)
}


function onLogingToLoginedFun() {
	console.log("onLogingToLoginedFun", wsState.state)
	// 重置重新连接的次数
	websock.pingCount = 0
	websock.connectRetryCount = 0
	websock.sendRetryCount = 0
	websock.normalClosed = false
	sendFixHeart('on')

	if (store.getters.getPingTips.code == 1) {
		store.dispatch('changePingTips', {
			code: codeAndTips.connectedCode,
			tipsText: codeAndTips.connectedTips
		})
	} else {
		store.dispatch('changePingTips', {
			code: null,
			tipsText: null
		})
	}
}


function onLoginedToPingFun() {
	console.log("onLoginedToPingFun", wsState.state)
	store.dispatch('changePingTips', {
		code: codeAndTips.offlineCode,
		tipsText: codeAndTips.offlineTips
	})
	sendFixHeart('off')
	wsPing()
}


function onLoginedAndFailedToLogoutFun() {
	console.log("onLoginedAndFailedToLogoutFun", wsState.state)
	sendFixHeart('off')
	router.push('/');
	setTimeout(() => {
		wsState.logoutToInit()
	}, 500)
}


function onPingToConFailedFun() {
	console.log("onPingToConFailedFun", wsState.state)
	setTimeout(() => {
		wsState.loginedAndFailedToLogout()
	}, 500)

}


function onPingToNnReconFun() {
	console.log("onPingToNnReconFun", wsState.state)
	store.dispatch('changePingTips', {
		code: codeAndTips.conningCode,
		tipsText: codeAndTips.conningTips
	})
	wsReconnect()


}

function onNnReconToFailedFun() {
	console.log("onNnReconToFailedFun", wsState.state)
	wsState.loginedAndFailedToLogout()
}

function onNnReconToConingFun() {
	console.log("onNnReconToConingFun", wsState.state)
	initWebSocket()


	if (websock.connected != true) {
		setTimeout(() => {
			console.log('已经重新连接第:' + websock.connectRetryCount + '次');
			if (wsState == 'sm_coning') {
				if (websock.connected != true) {
					wsReconnect()
				}
			}
		}, 5000)
	}
}

function onConingToLogoutFun() {
	console.log("onConingToLogoutFun", wsState.state)

	sendFixHeart('off')
	router.push('/');
	setTimeout(() => {
		wsState.logoutToInit()
	}, 500)
}



function onLogoutToInitFun() {
	console.log("onLogoutToInitFun", wsState.state)
	websock.connected = false
	websock.pingCount = 0
	websock.connectRetryCount = 0
	websock.sendRetryCount = 0
	console.log("websock.normalClosed====>", websock.normalClosed)
	if (websock.normalClosed == true) {
		websock.normalClosed = false
	} else {
		websock.normalClosed = false
		store.dispatch('changePingTips', {
			code: codeAndTips.connectFailedCode,
			tipsText: codeAndTips.connectFailedTips
		})
	}

}

function onLoginedToLogoutFun() {
	console.log("onLoginedToLogoutFun", wsState.state)
	wsState.logoutToInit()
	sendFixHeart('off')
	router.push('/');
}



function wsPing() {
	if (websock.pingCount >= connectCount) {
		wsState.pingToConFailed()
	} else {
		websock.pingCount++

		let webUrl = JSON.parse(localStorage.getItem("siteObj")).webUrl + '/ping'
		let httpRequest = new XMLHttpRequest()
		httpRequest.open('GET', webUrl, true);
		httpRequest.send()
		httpRequest.onreadystatechange = function () {
			if (httpRequest.readyState != 4) {
				return
			}
			if (httpRequest.readyState == 4 && httpRequest.status != 0) {
				wsState.pingToNnRecon()
			} else {
				setTimeout(() => {
					console.log('已经重新ping第:' + websock.pingCount + '次');
					wsPing()
				}, 5000)
			}
		}

	}
}




/**
 * 心跳检测机制:20秒发一个检测消息过去
 */
function sendFixHeart(onOff) {

	if (onOff == 'on') {
		util.sendFixHeartTimer = setInterval(() => {
			const heartObj = {
				type: '20',
				timestamp: util.nowTimeStamp(),
				data: {
					csid: util.getLocalAccount().id,
					status: util.getLocalAccount().userStatus
				}
			}

			websock.ws.send(JSON.stringify(heartObj));
		}, 20000);
	} else {
		clearInterval(util.sendFixHeartTimer);
		util.sendFixHeartTimer = null;
	}

}

function wsReconnect() {
	if (websock.connectRetryCount >= connectCount) {
		wsState.nnReconToFailedFun()
	} else {
		websock.connectRetryCount++
		setTimeout(() => {
			wsState.nnReconToConing()
		}, 500)
	}
}


class SocketService {
	instance = null
	//单例模式
	static get getOBJ() {
		if (SocketService.instance) {
			return SocketService.instance;
		}
		return (SocketService.instance = new SocketService());
	}
	// 和服务端连接的socket对象
	ws = null

	// 存储回调函数
	callBackMapping = {}

	// 标识是否连接成功
	connected = false

	// 记录重试的次数
	sendRetryCount = 0

	// 重新连接尝试的次数
	connectRetryCount = 0

	// 断网检测
	pingCount = 0;

	// 是否正常关闭
	normalClosed = false

	/**
	 * websocket连接
	 */
	connect(url) {
		// 连接服务器
		if (this.connected != true) {
			this.ws = new WebSocket(url)
		} else {
			this.ws = null
			this.ws = new WebSocket(url)
		}

		// 连接成功的事件
		this.ws.onopen = (e) => {
			console.log('连接服务端成功了,ws状态是' + this.ws.readyState);
			// this.wsState.connected()

			// this.sendFixHeart();
			websocketOpen(e)
		};

		// 当连接成功之后, 服务器关闭的情况 ｜  连接服务端失败
		this.ws.onclose = (e) => {
			console.log("监听ws关闭：", this.normalClosed)
			setTimeout(() => {
				console.log(e)

				if (this.normalClosed == true) {
					wsState.loginedAndFailedToLogout()
				} else {
					if (wsState.state == 'sm_coning') {
						wsState.coningToLogout()
					} else {
						wsState.loginedToPing()
					}

				}
			}, 1000)
			// websocketclose(e)

		};

		// websocket连接错误
		this.ws.onerror = function () {
			console.log('Error，websocket连接错误');
		};

		this.ws.onmessage = function (e) {
			websocketonmessage(e)
		}

	}
	send(data) {
		// 判断此时此刻有没有连接成功
		if (this.connected) {
			this.sendRetryCount = 0;

			this.ws.send(data);
		} else {
			this.sendRetryCount++;
			setTimeout(() => {
				this.send(data);
				console.log('已经重新发送第:' + this.sendRetryCount + '次');
			}, 5000);
		}
	}

	/**
	 * 关闭websocket连接
	 */
	close() {
		this.ws.close();
	}
}








// 初始化weosocket
function initWebSocket() {
	websock = SocketService.getOBJ
	if (!window.WebSocket) {
		wsState.coningToLogout()
		return console.log('您的浏览器不支持WebSocket');
	}
	if (localStorage.getItem("token") == null || localStorage.getItem("token") == 'null') {
		wsState.coningToLogout()
		return false
	}
	var wsUrl = process.env.VUE_APP_WSURL
	const site = util.getLocalSite()
	if (site !== null) {
		// wsUrl = site.wsUrl
		wsUrl = site.wsUrl + "?token=" + localStorage.getItem("token")
	}
	if (websock.ws == null || websock.ws.readyState == 3) {
		websock.connect(wsUrl)
		config.setWS(websock)
		console.log("websock对象", websock)
	}
	// websock = creatWS()

	// console.log("websock",websock)

	// websock.onmessage = function(e) {
	// 	websocketonmessage(e)
	// }
	// websock.onopen = function(e) {
	// 	websocketOpen(e)
	// }
	// websock.onerror = function(e) {
	// 	console.log("websock.onerror:", e)
	// 	util.setWsState('2')
	// 	// Message.error('ws连接异常，请稍候重试')
	// 	// errorCallback()
	// }
	// websock.onclose = function(e) {
	// 	websocketclose(e)
	// }
}

// 建立ws连接
function websocketOpen(e) {
	console.log('e = ', e)
	// reconnectionCount = 0
	// clearInterval(util.reconnectionTimer)

	// util.setWsState('1')
}

// 接收ws后端返回的数据
function websocketonmessage(e) {
	const jsonData = JSON.parse(e.data)
	console.log("jsonData", jsonData)
	if (jsonData.type === WSConnectSuccess) {
		//1-socket连接成功
		wsState.coningToLoging()
		// messageCallback(e)
	} else if (jsonData.type === '3') {
		//3.下线通知-别处登录
		messageType3(jsonData)
		if (messageCallback) {
			messageCallback(e)
		}

	} else if (jsonData.type === '4') {
		//会话被其他同事接管
		messageType4(jsonData)

	} else if (jsonData.type === '5') {
		//会话被其他同事接管
		messageType5(jsonData)

	} else if (jsonData.type === WSClientBrowsering) {
		//0-用户打开咨询页（客户浏览中）
		messageType10(jsonData)

	} else if (jsonData.type === WSClientTalking) {
		//11-用户开始会话（会话中）
		messageType11(jsonData)

	} else if (jsonData.type === WSLeaveToChat) {
		//聊天中
		messageType19(jsonData)

	} else if (jsonData.type == onlineCusromerAdd) {
		//添加在线访客
		messageType210(jsonData)
	} else if (jsonData.type == onlineCusromerLeave) {
		//移除在线访客
		messageType220(jsonData)
	} else if (jsonData.type === WSInChat) {
		//聊天中
		messageType12(jsonData)
		var sendJson = jsonData;
		sendJson.timestampStr = util.getFormatDate(0),
		sendJson.type = WSMsgRev;
		websocketSend(sendJson);

	} else if (jsonData.type === WSWorkInChat) {
		//同事聊天中
		messageType9(jsonData)

		var sendJson1 = jsonData;
		sendJson1.timestampStr = util.getFormatDate(0),
		sendJson1.type = WSMsgRev;
		websocketSend(sendJson1);
	} else if (jsonData.type === onlineCustomerAdd) {
		messageType210(jsonData)
	} else if (jsonData.type === onlineCustomerLeave) {
		messageType220(jsonData)
	} else if (jsonData.type === WSClientLeave) {
		//13-客户离开（已离开）
		messageType13(jsonData)
		store.dispatch('spliceOnlineData', jsonData.data)
		store.dispatch('addOffOnlineData', jsonData.data)
		// messageCallback(e) //通知聊天页面显示默然的图标

	} else if (jsonData.type === WSChatEnd) {
		//16-会话结束通知(对方结束会话)
		messageType16(jsonData)

	} else if (jsonData.type === WSHeartBeat) {
		//20-心跳
		messageType20(jsonData)
	} else if (jsonData.type === WSServerBack) {
		//99-服务器的回应消息
		messageBack99(jsonData)
	} else if (jsonData.type === '21') {
		//同事会话上线通知
		messageType21(jsonData)
	} else if (jsonData.type === '22') {
		//同事会话下线通知
		messageType22(jsonData)
	} else if (jsonData.type === '23') {
		//23 客服状态变更通知
		messageType23(jsonData)
	} else if (jsonData.type === '24') {
		//24 客服修改客户昵称或修改同事客户昵称通知
		messageType24(jsonData)
	} else if (jsonData.type === '25') {
		//25 客户状态变更通知(客户开口，未开口，转潜)
		messageType25(jsonData)
	} else if (jsonData.type === '26') {
		//普通聊天-修改会话中信息
		messageType26(jsonData)
	} else if (jsonData.type === '27') {
		//系统消息
		messageType27(jsonData)
	} else if (jsonData.type === '28') {
		messageType28(jsonData)
	} else if (jsonData.type == resetWorkList) {
		messageType30()
	} else if (jsonData.type == msgSendError) {
		// 消息发送失败
		messageType32(jsonData)
	} else if (jsonData.type == trusteeshipStatus) {
		// 托管状态
		messageType33(jsonData)
	} else if (jsonData.type == readedMsg) {
		//  消息已读
		messageType34(jsonData)
	}
	else if (jsonData.type === "230") {
		messageType230(jsonData)
	} else if (jsonData.type === "211") {
		messageType211(jsonData)
	} else if (jsonData.type === "2000") {
		// 智能助手话术
		messageType2000(jsonData)
	}
}
function messageType211(data) {
	console.log("同事访客事件触发:", data);
	const csid = data.data.csid
	if (store.state.colleageAngle && store.state.currentColleageInfo.id === csid) {
		store.commit('updateCsbrowserList', data)
	}
}
function messageType2000(data) {
	console.log("智能助手话术数据:", data);
	const payload = data.data || data
	// 写入 store，供输入框上方推荐条（网页/桌面共用）
	try {
		store.commit('setAiAssistantSuggest', payload)
	} catch (e) {
		console.error('setAiAssistantSuggest failed', e)
	}
	// 通过自定义事件传递数据到 QuickTalk 组件（原右侧面板保留）
	const event = new CustomEvent('aiAssistantData', {
		detail: payload
	});
	window.dispatchEvent(event);
}
function messageType230(data) {
	console.log("更新同事会话数:", data);
	store.dispatch('updateCollegeMessageCount', data)

}
function messageType28(data) {
	const currentTime = data.data.currentCsTimeLengthVo
	let account = util.getLocalAccount()
	account.timeLength = currentTime.csTimeLength
	util.setLocalAccount(JSON.stringify(account))
	store.state.authority.timeLength = currentTime.csTimeLength
	if (store.state.college.collegeTreeData.length === 0) {
		localStorage.setItem('type28Data', JSON.stringify(data))

		return
	}
	store.dispatch('updateCollegeTime', data)
}

function messageType30() {
	store.state.resetWorkListStatus = true
}

function messageType25(data) {
	const iAcceptor = data.data.accepter
	if (iAcceptor === 1) {
		//更新我的同事
		store.dispatch('updateClientStatus', data)
	} else if (iAcceptor === 0) {
		store.dispatch('updateSession', data)
	}
}

function messageType32(data) {
	console.log('websocket.js 32 data:', data);
	let { messageId, sendStatus } = data.data
	store.commit("upDateMessageState", { messageId, sendStatus })
}


// 机器人托管状态判断
function messageType33(data) {
	console.log('websocket.js 33 data:', data);
	const { csid, sid, trusteeshipStatus } = data.data

	let u_csid = util.getLocalAccount().id
	if (store.state.colleageAngle) {
		console.log(store.state.college);
		u_csid = store.state.currentColleageInfo.id

	}
	console.log('websocket.js 33 csid:', csid)
	console.log('websocket.js 33 u_csid:', u_csid)

	if (u_csid !== csid) {
		return
	}
	const sessionObj = getTalkingArrFormCsid(sid, store.state.colleageAngle)
	if (sessionObj) {
		sessionObj.trusteeship = trusteeshipStatus
	}

	console.log(sessionObj);

}

//消息已读
function messageType34(data) {
	console.log('websocket.js 34 data:', data);
	const { msgId } = data.data
	store.commit("addReadedStatusForMsg", { msgId})
}


function getTalkingArrFormCsid(sid, colleageAngle = false) {
	let talkingArr = store.state.talkingList
	if (colleageAngle) {
		talkingArr = store.state.cstalkingList
	}
	const res = talkingArr.find(item => {
		return item.sid === sid
	})
	return res
}

function messageType24(data) {
	const itype = data.data.type //1：客户昵称 2：客户备注 3：标签列表
	const iAcceptor = data.data.accepter
	if (itype === 1) {
		//修改左侧列表中昵称
		if (iAcceptor === 1) {
			//更新我的同事
			store.dispatch('updateClientNick', data)
		} else if (iAcceptor === 0) {
			//我的同事把我的客户的昵称修改了
			const obj = {
				cid: data.data.cid,
				sid: data.data.csid,
				nickname: data.data.content
			}
			store.dispatch('updateListNick', obj)
		}
	} else if (itype === 3) {
		//我的同事
		if (iAcceptor === 1) {
			store.dispatch('updateClientLabels', data)
			// store.state.college.nowSelectClient.labels = data.data.content
		} else if (iAcceptor === 0) {
			// store.state.selectedClient.labels = data.data.content
			const obj = {
				csid: data.data.csid,
				cid: data.data.cid,
				sid: data.data.csid,
				nickname: data.data.content
			}
			store.dispatch('updateListLabels', obj)
		}
	}

	upClientDetail(data)
}

function upClientDetail(data) {
	const iAcceptor = data.data.accepter
	var nowSelected = null
	if (iAcceptor === 1) {
		//更新我的同事列表
		nowSelected = store.state.college.nowSelectClient
		if (nowSelected !== null) {
			const cid = data.data.cid
			if (nowSelected.cid === cid) {
				store.state.toUpDetail = {
					'type': data.data.type,
					'content': data.data.content,
				}

			}
		}
	} else if (iAcceptor === 0) {
		//更新我的会话列表
		nowSelected = store.state.selectedClient
		if (nowSelected !== null) {
			const cid = data.data.cid
			if (nowSelected.cid === cid) {
				store.state.toUpDetail = {
					'type': data.data.type,
					'content': data.data.content,
				}

			}
		}
	}
}

function messageType23(data) {
	store.dispatch('updateCollegeState', data)
}

function messageType26(data) {
	const iAccepter = data.data.accepter
	var nowSelected = null
	if (iAccepter === 0) {
		store.dispatch('updateClientInfo', data)
		nowSelected = store.state.selectedClient
		if (nowSelected !== null) {
			const cid = data.data.sess.cid
			if (nowSelected.cid === cid) {
				const itype = data.data.type
				const content = data.data.content
				if (itype === 5) {
					nowSelected.age = content
				} else if (itype === 2) {
					nowSelected.tel = content
				} else if (itype === 6) {
					nowSelected.gender = content
				}

				store.state.toUpDetail = {
					'type': 4,
					'content': content,
				}

			}
		}

	} else if (iAccepter === 1) {
		store.dispatch('updateCollegeInfo ', data)

		nowSelected = store.state.college.nowSelectClient
		if (nowSelected !== null) {
			const cid = data.data.sess.cid
			if (nowSelected.cid === cid) {
				const itype = data.data.type
				const content = data.data.content
				if (itype === 5) {
					nowSelected.age = content
				} else if (itype === 2) {
					nowSelected.tel = content
				} else if (itype === 6) {
					nowSelected.gender = content
				}

				store.state.toUpDetail = {
					'type': 4,
					'content': content,
				}

				const type = data.data.type
				const message = data.data.message
				store.state.iAutoChange = {
					'type': type,
					'content': content,
					'message': message,
					'cid': nowSelected.cid,
					'sid': nowSelected.sid
				}

			}
		}
	}
}

function messageType27(data) {
	const iAccepter = data.data.accepter
	const sess = data.data.sess

	if (iAccepter === 0) {
		const selected = store.state.selectedClient
		if (selected === null) {
			return
		}
		if (selected.cid === sess.cid) {
			store.dispatch('addSystemTip', data)
		}
	} else if (iAccepter === 1) {
		// store.dispatch('addCollegeSysTip', data)
		if (store.state.college.nowSelectClient !== null) {
			//发的消息正好是我打开的聊天界面
			let selectedCid = store.state.college.nowSelectClient.cid
			// let selectedSid = store.state.college.nowSelectClient.sid
			if (selectedCid === sess.cid) {
				//在对话框中显示消息内容
				store.dispatch('addSystemTip', data)
			}
		}
	}
}




function messageType3(data) {
	store.state.authority.type3Data = data
	util.setWsState('3')
	util.setLoginTip('0')
	closeWebsocket()
}

function messageType21(data) {
	console.log("同事会话上线，触发");
	store.dispatch('addCollegeSession', data)
}

function messageType22(data) {
	console.log("同事会话下线，触发");
	store.dispatch('delCollegeSession', data)
}

function messageType4(data) {
	store.commit('adapterTalkObj', data.data.sess)

	setTimeout(() => {
		if (store.state.adapteredClient !== null) {
			const tipstr = '你的客户' + '【' + store.state.adapteredClient.nickname + '】' + '已被同事' + '【' + data.data
				.t_csname + '】' +
				'接管了！'
			Message.error(tipstr)
		}
	}, 500);
}

function messageType5(data) {
	store.commit('spliceTalkObj', data.data.sess)
}

function messageType10(data) {
	console.log("访客进站不开口");
	store.dispatch('addBrowerData', data.data)
	store.commit('spliceLeaveObj', data.data)
}

function messageType11(data) {
	console.log("访客进站且开口");
	console.log('websocket messageType11 data = ', data)

	if (store.state.colleageAngle) {
		store.state.haveMessage = true
	}
	store.dispatch('addTalkData', data.data)
	store.commit('spliceBrowerObj', data.data)
	store.commit('spliceLeaveObj', data.data)
}

function messageType19(data) {
	console.log('websocket messageType19 data = ', data)
	store.dispatch('addTalkData', data.data)
	store.commit('spliceLeaveObj', data.data)
}

function messageType210(data) {
	console.log('websocket messageType210 data = ', data)
	store.dispatch('addOnlineData', data.data)
}

function messageType220(data) {
	console.log('websocket messageType220 data = ', data)
	store.commit('spliceOnlineData', data.data)
	store.commit('spliceOffOnlineData', data.data)
}

function isPlayFlicker() {
	util.playFlickerAudio()
}

function popNotice() {
	// 判断是否处于最小化状态
	if (document.visibilityState === 'hidden') {
		if (window.Notification) { // 判断是否支持提醒
			//判断是否允许提醒
			if (Notification.permission === 'granted') { // 允许的话弹出提醒
				pop()
			} else if (Notification.permission !== 'denied') { // 不允许的话重新询问浏览器是否可以接收提醒
				Notification.requestPermission(function (permission) {
					console.log('popNotice permission = ', permission)
					pop()
				})
			}
		} else {
			alert('你的浏览器不支持此消息提示功能，请使用chrome内核的浏览器！')
		}
	}
}

// 弹出提醒框
function pop() {

	unReadTotal = unReadTotal + 1
	if (userAgent.indexOf('electron/') == -1) {
		const notification = new Notification('您有未读消息：', {
			// body: `${name ? name : '未知客户'}，${number}（${areaInfo.province}/${areaInfo.city}），请注意接听！`,
			body: `${unReadTotal}条，请注意查收！`
			// icon: './t'
		})
		notification.onclick = (() => {
			// 点击后进行的操作
			notification.close() // 关闭提醒框
		})
	}

}

function messageType12(data) {
	console.log("data.data.msg.matchedKw：", data.data.msg.matchedKw);
	let cid = data.data.sess.cid
	let sid = data.data.sess.sid
	let msg = data.data.msg.content
	console.log("msg====:", msg);
	const iFrom = data.data.msg.from
	if (iFrom === 1 || iFrom === 2 || iFrom === 3) {
		console.log('messageType12 ifrom = ', iFrom)
	} else {
		popNotice()
	}

	if (msg === '$$压测压测恭喜发财$$') {
		store.state.authority.testTag = '1'
	}
	if (msg === '$$压测压测拜拜$$') {
		store.state.authority.testTag = '0'
	}

	

	var msgObj = null

	//没有选择任何客户
	if (store.state.selectedClient === null) {
		//找到相应用户，显示红色未读消息的标记
		msgObj = findClientInTalk(cid, sid)
		// if (msgObj === null) {
		// 	msgObj = findClentInBrower(cid, sid)
		// }
		if (msgObj !== null) {
			const iFrom = data.data.msg.from
			//0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
			if (iFrom === 1 || iFrom === 2 || iFrom === 3) {
				// msgObj.isFlicker = false
				console.log(11111);
			} else {
				if (store.state.colleageAngle) {
					store.state.haveMessage = true
				}
				// msgObj.unread_msg_count = parseInt(msgObj.unread_msg_count) + 1
				if (data.data.msg.type === "text") {
					msgObj.content = msg
				}
				msgObj.unread_msg_count += 1
				msgObj.isFlicker = true
				console.log(" messageType12 msgObj", msgObj)
				if (data.data.msg.matchedKw) {
					console.log("进入关键词提示音效");
					store.dispatch('playKeyRadio_')
				} else {
					isPlayFlicker()
				}
				if (userAgent.indexOf('electron/') != -1) {
					ipc.send("news");
				}
			}
		}
	} else {
		//1、如果发的消息正好是我打开的聊天界面
		let selectedCid = store.state.selectedClient.cid
		// let selectedSid = store.state.selectedClient.sid
		if (selectedCid === cid) {
			//在对话框中显示消息内容
			console.log("如果发的消息正好是我打开的聊天界面");
			//store.state.isScrollMsg = false;
			let type = data.data.msg.type
			var isMine = false
			var name = store.state.selectedClient.nickname
			const iFrom = data.data.msg.from
			var imgUrl = ''
			store.state.selectedClient.isFlicker = false
			console.log("type12 store.state.selectedClient:", store.state.selectedClient);
			//0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
			if (iFrom === 1 || iFrom === 3 || iFrom === 2) {
				isMine = true
				name = data.data.csname
				imgUrl = require("../../static/talks/t_severbig.png")
				if (util.nullToString(data.data.cs_portrait) !== '') {
					imgUrl = data.data.cs_portrait
				}
				if (iFrom === 2) {
					imgUrl = require("../../static/talks/t_robot.png")
				}
			} else if (iFrom === 0) {
				if (type === "text") {
					store.state.selectedClient.content = msg
					console.log(" type12 添加最新内容", store.state.selectedClient);
				}
				msgObj = findClientInTalk(cid, sid)
				// if (msgObj === null) {
				// 	msgObj = findClentInBrower(cid, sid)
				// }
				msgObj.isFlicker = false
				console.log("findClientInTalk(cid, sid)2", msgObj)
				if (data.data.msg.matchedKw) {
					console.log("进入关键词提示音效");
					store.dispatch('playKeyRadio_')
				} else {
					isPlayFlicker()
				}
				if (userAgent.indexOf('electron/') != -1) {
					ipc.send("news");
				}
			}
			var msgDic = null
			if (type === 'text') {
				msgDic = {
					"date": util.timeStampToDate(data.data.msg.timestamp * 1000, 0),
					"text": {
						"text": data.data.msg.content,
						"type": data.data.msg.type,
					},
					"mine": isMine,
					"name": name,
					"avar": imgUrl,
					"type": '0', //0-客服或客户发的消息 1-系统提醒消息
					"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
					"sendStatus": 1,
					// "origin":iFrom
				}

			} else if (type === 'image') {
				let imgText = '<img data-src=' + data.data.msg.content + '>'
				msgDic = {
					"date": util.timeStampToDate(data.data.msg.timestamp * 1000, 0),
					"text": {
						text: imgText,
						type: data.data.msg.type,
					},
					"mine": isMine,
					"name": name,
					"img": data.data.msg.content,
					"avar": imgUrl,
					"type": '0', //0-客服或客户发的消息 1-系统提醒消息
					"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
					"sendStatus": 1
					// "origin":iFrom
				}
			} else if (type === 'video') {
				let imgText = '<video data-src=' + data.data.msg.content + '>'
				msgDic = {
					"date": util.timeStampToDate(data.data.msg.timestamp * 1000, 0),
					"text": {
						text: imgText,
						type: data.data.msg.type,
					},
					"mine": isMine,
					"name": name,
					"img": data.data.msg.content,
					"avar": imgUrl,
					"type": '0', //0-客服或客户发的消息 1-系统提醒消息
					"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
					"sendStatus": 1
					// "origin":iFrom
				}
			} else if (type === 'audio') {
				let audioText = '<audio data-src=' + data.data.msg.content + '>'
				msgDic = {
					"date": util.timeStampToDate(data.data.msg.timestamp * 1000, 0),
					"text": {
						text: audioText,
						type: data.data.msg.type,
					},
					"mine": isMine,
					"name": name,
					"img": data.data.msg.content,
					"avar": imgUrl,
					"type": '0', //0-客服或客户发的消息 1-系统提醒消息
					"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
					"sendStatus": 1
					// "origin":iFrom
				}
			}
			if (store.state.selectedChatList === null) {
				store.state.selectedChatList = []
			}

			if (data.data.msg.id) {
				msgDic.id = data.data.msg.id
			}
			console.log("如果发的消息是我打开的聊天界面  msgDic", msgDic);
			store.state.selectedChatList.push(msgDic)
			// var api = "/manager/session/sessmsg/readed/" + sid
			// const response = util.postRequest({
			// 	url: api,
			// 	method: "GET",
			// })
			// console.log("clientList readCountRequest response = ", response)
		} else {
			console.log("如果发的消息不是我打开的聊天界面");
			//2、发的消息不是我打开的聊天界面
			msgObj = findClientInTalk(cid, sid)
			console.log("type12 msgObj:", msgObj);
			// if (msgObj === null) {
			// 	msgObj = findClentInBrower(cid, sid)
			// }
			if (msgObj !== null) {
				const iFrom = data.data.msg.from
				//0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
				if (iFrom === 1 || iFrom === 2 || iFrom === 3) {
					// if (data.data.msg.matchedKw) {
					// 	console.log("进入关键词提示音效");
					// 	store.dispatch('playKeyRadio_')
					// } else {
					// 	isPlayFlicker()
					// }
					console.log("非客户发送消息");
				} else {
					if (store.state.colleageAngle) {
						store.state.haveMessage = true
					}
					if (data.data.msg.type === "text") {
						msgObj.content = msg
						console.log(" type12 添加最新内容", msgObj.content);
					}
					msgObj.unread_msg_count = data.data.unread_count
					msgObj.isFlicker = true
					console.log("findClientInTalk(cid, sid)3", msgObj)
					if (data.data.msg.matchedKw) {
						console.log("进入关键词提示音效");
						store.dispatch('playKeyRadio_')
					} else {
						isPlayFlicker()
					}
					if (userAgent.indexOf('electron/') != -1) {
						ipc.send("news");
					}
				}
			}
		}
	}

	store.dispatch('updateCount', data)
	const iFrom11 = data.data.msg.from
	if (iFrom11 === 0) {
		// 推送消息给 clientItem，触发进度更新
		store.commit('updateProgressNotify', {
			cid: cid,
			sid: sid
		})
	} 
	

}

function messageType9(data) {
	let cid = data.data.sess.cid
	let sid = data.data.sess.sid
	let msg = data.data.msg.content

	console.log("messageType9触发");
	console.log("msg====:", msg);
	const iFrom = data.data.msg.from
	if (iFrom === 1 || iFrom === 2 || iFrom === 3) {
		console.log('messageType12 ifrom = ', iFrom)
	} else {
		popNotice()
	}
	var msgObj = null
	//1、如果我没有选择客户
	if (store.state.college.nowSelectClient === null) {
		// //找到相应用户，显示红色未读消息的标记
		msgObj = findColleagueClientInTalk(cid, sid)
		// if (msgObj === null) {
		// 	msgObj = findColleagueClentInBrower(cid, sid)
		// }
		if (msgObj !== null) {
			const iFrom = data.data.msg.from
			//0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
			if (iFrom === 1 || iFrom === 2 || iFrom === 3) {
				console.log("没有选择相应的用户");
			} else {
				if (data.data.msg.type === "text") {
					// console.log("messageType9 没有选择相应的用户 Vue", Vue.set);
					Vue.set(msgObj, 'content', msg)
				}
				console.log("没有选择相应的用户,msgObj", msgObj);
				msgObj.unread_msg_count += 1
				msgObj.isFlicker = true
				console.log("findClientInTalk(cid, sid)1", msgObj.isFlicker)
				console.log("type 9 cstalkingList", store.state.cstalkingList)
			}
		}
	} else {
		// 2.有选择的客户
		//找到相应用户，显示红色未读消息的标记
		//1、发的消息正好是我打开的聊天界面
		let selectedCid = store.state.college.nowSelectClient.cid
		if (selectedCid === cid) {
			//在对话框中显示消息内容
			console.log("如果发的消息正好是我同事打开的聊天界面");
			let type = data.data.msg.type
			var isMine = false
			var name = store.state.college.nowSelectClient.nickname
			var imgUrl = ''
			const iFrom = data.data.msg.from
			store.state.college.nowSelectClient.isFlicker = false
			//0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
			if (iFrom === 1 || iFrom === 3 || iFrom === 2) {
				isMine = true
				name = data.data.csname
				imgUrl = require("../../static/talks/t_severbig.png")
				console.log("客服发送图片，", data.data.cs_portrait);
				if (util.nullToString(data.data.cs_portrait) !== '') {
					imgUrl = data.data.cs_portrait
				}

				if (iFrom === 2) {
					imgUrl = require("../../static/talks/t_robot.png")
				}
			} else if (iFrom === 0) {
				if (type === "text") {
					store.state.college.nowSelectClient.content = msg
					console.log(" type12 添加最新内容", store.state.college.nowSelectClient);
				}
				console.log("type12 访客发送图片");
				msgObj = findColleagueClientInTalk(cid, sid)
				// if (msgObj === null) {
				// 	msgObj = findColleagueClentInBrower(cid, sid)
				// }
				msgObj.isFlicker = false

			}
			var msgDic = null
			if (type === 'text') {
				msgDic = {
					"date": util.timeStampToDate(data.data.msg.timestamp * 1000, 0),
					"text": {
						"text": util.replaceBdToEmoji(data.data.msg.content),
						"type": data.data.msg.type,
					},
					"mine": isMine,
					"name": name,
					"avar": imgUrl,
					"type": '0', //0-客服或客户发的消息 1-系统提醒消息
					"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
					"sendStatus": 1
					// ""origin":iFrom": iFrom, //0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
				}
			} else if (type === 'image') {
				let imgText = '<img data-src=' + data.data.msg.content + '>'
				msgDic = {
					"date": util.timeStampToDate(data.data.msg.timestamp * 1000, 0),
					"text": {
						text: imgText,
						type: data.data.msg.type,
					},
					"mine": isMine,
					"name": name,
					"img": data.data.msg.content,
					"avar": imgUrl,
					"type": '0', //0-客服或客户发的消息 1-系统提醒消息
					"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
					"sendStatus": 1
					// "iFrom": iFrom, //0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
				}
			} else if (type === 'video') {
				let imgText = '<video data-src=' + data.data.msg.content + '>'
				msgDic = {
					"date": util.timeStampToDate(data.data.msg.timestamp * 1000, 0),
					"text": {
						text: imgText,
						type: data.data.msg.type,
					},
					"mine": isMine,
					"name": name,
					"img": data.data.msg.content,
					"avar": imgUrl,
					"type": '0', //0-客服或客户发的消息 1-系统提醒消息
					"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
					"sendStatus": 1
					// "iFrom": iFrom, //0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
				}
			} else if (type === 'audio') {
				let audioText = '<audio data-src=' + data.data.msg.content + '>'
				msgDic = {
					"date": util.timeStampToDate(data.data.msg.timestamp * 1000, 0),
					"text": {
						text: audioText,
						type: data.data.msg.type,
					},
					"mine": isMine,
					"name": name,
					"img": data.data.msg.content,
					"avar": imgUrl,
					"type": '0', //0-客服或客户发的消息 1-系统提醒消息
					"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
					"sendStatus": 1
					// "iFrom": iFrom, //0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
				}
			}
			console.log('websocket messageType9 ui msgDic = ', msgDic)
			if (store.state.selectedChatList === null) {
				store.state.selectedChatList = []
			}
			if (data.data.msg.id) {
				msgDic.id = data.data.msg.id
			}
			store.state.selectedChatList.push(msgDic)
			// console.log('websocket messageType9 store.state.selectedChatList=添加后 ', store.state.selectedChatList)
		} else {
			console.log("如果发的消息不是我同事打开的聊天界面");
			//2.发的消息不是我同事打开的聊天界面
			msgObj = findColleagueClientInTalk(cid, sid)
			// if (msgObj === null) {
			// 	msgObj = findColleagueClentInBrower(cid, sid)
			// }
			if (msgObj !== null) {
				const iFrom = data.data.msg.from
				//0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
				if (iFrom === 1 || iFrom === 2 || iFrom === 3) {
					console.log("非客户发送消息");
				} else {
					if (data.data.msg.type === "text") {
						msgObj.content = msg

						console.log(" type12 添加最新内容", msgObj.content);
					}
					msgObj.unread_msg_count = data.data.unread_count
					msgObj.isFlicker = true
					console.log("findClientInTalk(cid, sid)3", msgObj)
				}
			}
		}
	}
	store.dispatch('updateClientMsgCount', data)

	// 推送消息给 clientItem，触发进度更新
	// store.commit('updateProgressNotify', {
	// 	cid: cid,
	// 	sid: sid
	// })
	console.log("updateProgressNotify");
}





function findClientInTalk(cid, sid) {
	console.log('websocket findClientInTalk sid = ', sid)
	let talkingAry = store.state.talkingList
	var msgObj = null
	for (var i = 0; i < talkingAry.length; i++) {
		var talkObj = talkingAry[i]
		if (talkObj.cid === cid) {
			msgObj = talkObj

			return talkObj
		}
	}
	return msgObj
}
// 同事的对话
function findColleagueClientInTalk(cid, sid) {
	console.log('websocket findCsClientInTalk sid = ', sid)
	let talkingAry = store.state.cstalkingList
	var msgObj = null
	for (var i = 0; i < talkingAry.length; i++) {
		var talkObj = talkingAry[i]
		if (talkObj.cid === cid) {
			msgObj = talkObj
			return talkObj
		}
	}
	return msgObj
}


// function findClientInOnline(cid, sid) {
// 	console.log('websocket findClientInOnline sid = ', sid)
// 	let onlineAry = store.state.onlineList

// 	var msgObj = null
// 	for (var i = 0; i < onlineAry.length; i++) {
// 		var onlineObj = onlineAry[i]
// 		if (onlineObj.cid === cid) {
// 			msgObj = onlineObj

// 			return onlineObj
// 		}
// 	}

// 	return onlineObj
// }


function findClentInBrower(cid, sid) {
	console.log('websocket findClentInBrower sid = ', sid)
	let browserAry = store.state.browserList
	var msgObj = null
	for (var i = 0; i < browserAry.length; i++) {
		var browserObj = browserAry[i]
		if (browserObj.cid === cid) {
			msgObj = browserObj
			return msgObj
		}
	}

	return msgObj
}
// function findColleagueClentInBrower(cid, sid) {
// 	console.log('websocket findClentInBrower sid = ', sid)
// 	let browserAry = store.state.csbrowserList
// 	var msgObj = null
// 	for (var i = 0; i < browserAry.length; i++) {
// 		var browserObj = browserAry[i]
// 		if (browserObj.cid === cid) {
// 			msgObj = browserObj
// 			return msgObj
// 		}
// 	}
// 	return msgObj
// }

function messageType13(data) {
	console.log("自己对话，访客离站触发：", data);
	if (store.state.leavedList === null) {
		store.state.leavedList = []
	}
	let cid = data.data.sess.cid
	let sid = data.data.sess.sid
	let isSpeaked = data.data.sess.isSpeaked
	var msgObj = null
	var isTalk = true
	msgObj = findClientInTalk(cid, sid)
	if (msgObj === null) {
		msgObj = findClentInBrower(cid, sid)
		isTalk = false
	}
	//会话列表中删除相应客户，leaves/talked中添加可以
	if (msgObj !== null) {
		var selected = store.state.selectedClient
		if (selected !== null) {
			const cid = data.data.sess.cid
			if (selected.cid === cid) {
				store.state.selectedClient = null
			}
		}
		if (isSpeaked) {
			store.dispatch('addTalkedData', msgObj)
		} else {
			store.dispatch('addLeaveData', msgObj)
		}
	}

	if (isTalk) {
		//从会话列表删除
		var talkingList = store.state.talkingList
		for (var i = 0; i < talkingList.length; i++) {
			var talk = talkingList[i]
			if (talk.cid === cid) {
				store.state.talkingList.splice(i, 1)
			}
		}
	} else {
		// 从浏览中删除
		var browerList = store.state.browserList
		for (var j = 0; j < browerList.length; j++) {
			var browser = browerList[j]
			if (browser.cid === cid) {
				store.state.browserList.splice(j, 1)
			}
		}
	}
}

function messageType14() {

	const selected = store.state.selectedClient
	// if (!store.state.colleageAngle) {
	if (store.state.selectedKey !== 4) {
		//从会话中删除相应的客户
		var talkingList = store.state.talkingList
		for (let i = 0; i < talkingList.length; i++) {
			var talk = talkingList[i]
			if (talk.cid === selected.cid) {
				store.state.talkingList.splice(i, 1)
			}
		}
		store.dispatch('addLeaveData', selected)

	}
	// else {
	// 	//将会话从我的同事的session中删除
	// 	var parent = store.state.parentNode
	// 	var sessionList = parent.data.data.chastSeesion
	// 	for (var i = 0; i < sessionList.length; i++) {
	// 		const session = sessionList[i]
	// 		if (session.cid === selected.cid && session.sid === selected.sid) {
	// 			sessionList.splice(i, 1)
	// 		}
	// 	}

	// 	parent.loaded = false
	// 	parent.expand()

	// 	store.state.selectedClient = null
	// }
}

function messageType16(data) {
	messageType13(data)
}

function messageType20(data) {
	console.log('websocket messageType20 data = ', data)
	//接收到之后给服务器端回应

}




function messageBack99(data) {
	console.log("消息回馈 消息回馈类型", data.data.reply_type);
	console.log(data);
	if (data.data.reply_type) {
		if (data.data.reply_type === ConnectWithToken) {
			if (data.data.reply_code !== WSLoginSuccess) {
				//403-token过期
				if (data.data.reply_code === 403 || data.data.reply_code === 400) {
					// errorCallback(data)
					util.setWsState('4')
					util.setLoginTip('0')

				} else {
					Message.error(data.data.reply_msg)
				}
			} else {
				wsState.logingToLogined()

			}
		} else if (data.data.reply_type === WSHeartBeat) {
			util.wsReconCount = 0
		} else if (data.data.reply_type === WSInChat) { //聊天
			if (data.data.reply_code === 499) {
				Message.error(data.data.reply_msg + '，消息发送失败')
				//return
			} else if (data.data.reply_code === 500) {
				Message.error(data.data.reply_msg)
				//return
			}
			store.dispatch('pushChatList', data)
			store.dispatch('updateCount', store.state.toServerChatObj)

		} else if (data.data.reply_type === WSWorkInChat) { //聊天
			if (data.data.reply_code === 499) {
				Message.error(data.data.reply_msg + '，消息发送失败')
				return
			} else if (data.data.reply_code === 500) {
				Message.error(data.data.reply_msg)
				return
			}
			store.dispatch('pushChatList', data)
			store.dispatch('updateClientMsgCount', store.state.toServerChatObj)

		} else if (data.data.reply_type === '8') {
			if (data.data.reply_code === 400 || data.data.reply_code === 499) {
				Message.error(data.data.reply_msg)
			}
		} else if (data.data.reply_type === WSCustomLeave) {
			if (data.data.reply_code === 200) {
				//14-客服主动结束（客户）会话 ----从会话中删除
				messageType14()
				// messageCallback() //通知聊天页面显示默然的图标

			} else if (data.data.reply_code === 499 || data.data.reply_code === 500) {
				Message.error(data.data.reply_msg)
			}
		}
	}
}





/**
 * 发起websocket连接
 * @param {Object} agentData 需要向后台传递的参数数据
 */
function websocketSend(agentData) {

	// 加延迟是为了尽量让ws连接状态变为OPEN
	if (websock && websock.ws.readyState === websock.ws.OPEN) { // websock.OPEN = 1
		// 发给后端的数据需要字符串化
		console.log("正在发送数据", agentData, websock.ws.readyState, websock.ws.OPEN)
		websock.send(JSON.stringify(agentData))
	}
	// 若是 正在开启状态，则等待300毫秒
	else if (websock && websock.readyState === websock.CONNECTING) {
		// let that = this;//保存当前对象this
		// setTimeout(function() {
		// 	websock.send(JSON.stringify(agentData))
		// }, 300);
	}
	// 若未开启 ，则等待500毫秒
	else { // websock.CLOSED = 3
		// if (websock.readyState === 3) {
		// 	connectWebsocket2()
		// }
		// this.initWebSocket();
		// // let that = this;//保存当前对象this
		// setTimeout(function() {
		// 	websock.send(JSON.stringify(agentData))
		// }, 500);
		// console.log('websock.readyState=3')
		// // Message.error('ws连接异常，请稍候重试')
		if (null != errorCallback) {
			errorCallback()
		}
	}
}

// function sendHeartbeat() {
// 	const heartObj = {
// 		type: '20',
// 		timestamp: util.nowTimeStamp(),
// 		data: {
// 			csid: util.getLocalAccount().id,
// 			status: util.getLocalAccount().userStatus
// 		}
// 	}

// 	util.wsReconCount = util.wsReconCount + 1
// 	console.log("=============================", util.wsReconCount)
// 	if (util.wsReconCount > 5) {
// 		clearInterval(util.heartTimer)
// 		// store.state.authority.wsStateTag = '2'
// 		util.wsReconCount = 0
// 		connectWebsocket2()

// 		return
// 	}
// 	// console.log('utils websocket sendHeartbeat heartObj = ', heartObj)
// 	websocketSend(heartObj)
// }

/**
 * 发起websocket请求函数
 * @param {string} url ws连接地址
 * @param {Object} agentData 传给后台的参数
 * @param {function} successCallback 接收到ws数据，对数据进行处理的回调函数
 * @param {function} errCallback ws连接错误的回调函数
 */
export function sendWebsocket(agentData, successCallback, errCallback) {
	messageCallback = successCallback
	errorCallback = errCallback
	websocketSend(agentData)
}


//连接websocket ---- 带回调函数
export function connectWebsocket1(successCallback, errCallback) {
	initWebSocket()
	messageCallback = successCallback
	errorCallback = errCallback
}

//连接websocket ----不带回调函数
export function connectWebsocket2() {
	wsState.initToConing()
}


//关闭websocket函数-不带回调函数
export function closeWebsocket() {
	// console.log(websock)

	// console.log("websockState",websock,websock.ws.readyState,websock.ws.CLOSING,websock.connected);
	// if(websock!=null){
	// 	if (websock.connected == true) { //如果ws还在，则关闭
	// 		websock.normalClosed = true
	// 		websock.close() // 关闭websocket
	// 		// websock.onclose() // 关闭websocket
	// 	}
	// }
	if (websock != null) {

		websock.normalClosed = true
		websock.close()

	}

}
